<template>
    <div style="background:#fff; width:100%; height:auto; position: relative; padding: 0; margin:0" >
      <div class="ibox-title">
        <h3>Select Client</h3>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="col-lg-4 col-md-4 m-t-sm">
          <v-select placeholder="Select Client" :options="clients" label="label" v-model="selectedClient" @change="selectClient">
          </v-select>
        </div>
        <div class="col-lg-4 col-md-4 m-t-sm" v-if="client.filter.user" >
          <v-select placeholder="Select Order Status" :options="linkStatus" label="label" v-model="selectedStatus" @input="selectLinkStatus" >
          </v-select>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <div v-if="links.length" style="padding:20px">
    <table class="table table-dark">
    <thead>
    <tr>
        <th>#ID</th>
        <th>Website</th>
        <th>Target Url</th>
        <th>Client Price</th>
        <th>Target Anchor</th>
        <th>Description</th>
        <th>Live Link</th>
        <th>Published Date</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="link in links" :key="link.id">
        <td>{{ link.id }}</td>
        <td>{{ link.website }}</td>
        <td>{{ link.targetWebsite }}</td>
        <td>{{ (link.price||0).toFixed(2) }}</td>
        <td>{{ link.targetAnchor }}</td>
        <td>{{ link.topic }}</td>
        <td>{{ link.publishedUrl }}</td>
        <td>{{ link.completedAt?moment(link.completedAt).format('DD/MM/YYYY'):'' }}</td>
    </tr>
    </tbody>
    </table>
    <div style="background-color: #fff; padding: 10px 10px 20px">
      <div style="float:left">
        <span><strong>Records: </strong>{{ client.totalPages }}</span>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </div>
      <div style="float:right">
        <strong for="pageSize">Rows:&nbsp;</strong>
        <select id="pageSize" v-model="client.options.perPage" @change="setPageSize">
          <option v-for="size in client.pageSizes" :value="size" :key="size">{{ size }}</option>
        </select>
      </div>
      <div style="text-align: center;">
        <div style="display:inline-block"><button @click="prevPage" :disabled="client.options.page === 1">Previous</button>&nbsp;&nbsp;</div>
        <div style="display:inline-block"><span>&nbsp;{{ client.options.page }} / {{ Math.ceil(client.totalPages/client.options.perPage) }}&nbsp;</span></div>
        <div style="display:inline-block">&nbsp;&nbsp;&nbsp;<button @click="nextPage" :disabled="client.options.page >= client.totalPages/client.options.perPage">Next</button></div>
      </div>
    </div>
  </div>
      <div style="clear:both; padding:20px"></div>
    </div>
  </template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  data () {
    return {
      moment,
      linkStatus: [
        {label: 'WM Contact or Pending', value: 'WM Contact or Pending'},
        {label: 'WM Contacted', value: 'WM Contacted'},
        {label: 'Content in progress', value: 'Content in progress'},
        {label: 'Content sent for approval', value: 'Content sent for approval'},
        {label: 'Content sent for publishing', value: 'Content sent for publishing'},
        {label: 'WM Rejected', value: 'WM Rejected'},
        {label: 'WM Link Placed', value: 'WM Link Placed'}
      ],
      client: {
        id: null,
        filter: {},
        options: {
          page: 1,
          perPage: 10
        },
        totalPages: 0,
        pageSizes: [10, 25, 50, 100]
      },
      links: [],
      filter: {
        roles: 'client'
      },
      options: {
        perPage: 1000
      },
      report: null,
      clients: []
    }
  },
  beforeMount () {
    this.getClients()
  },
  methods: {
    async selectLinkStatus (link) {
      if (!link) {
        delete this.client.filter.status
      } else {
        this.client.filter = {
          ...this.client.filter,
          status: link.value
        }
      }
      this.getClientLinks()
    },
    async selectClient (user) {
      this.client.filter = {
        ...this.client.filter,
        user: user.value
      }
      this.getClientLinks()
    },
    async getClientLinks () {
      const res = await axios.get(`/v2/instalinko/links`, {params: { filter: this.client.filter, options: this.client.options }})
      this.client.totalPages = Number(res.headers['x-total-records'])
      this.links = res.data
    },
    async getClients (e) {
      // this.report = e.value
      const {data} = await axios.post('/v2/instalinko/users/list', {filter: this.filter, options: this.options})
      this.clients = data.map(obj => ({label: obj.name, value: obj.id}))
    },
    setPageSize (e) {
      this.client.options.perPage = e.target.value
      this.getClientLinks()
    },
    nextPage () {
      if (this.client.options.page < this.client.totalPages) {
        this.client.options.page++
        this.getClientLinks()
      }
    },
    prevPage () {
      if (this.client.options.page > 1) {
        this.client.options.page--
        this.getClientLinks()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/Reports/ClientOrderReports.vue